module.exports = __webpack_public_path__ + "img/blue_123.dfe01475.png";